import { Box, Collapse, Typography } from "@mui/material";
import React, { useState } from "react";
import expandIcon from "../../../../assets/icons/expandDown.svg";
import shrinkIcon from "../../../../assets/icons/expandUp.svg";
import moneyIcon from "../../../../assets/icons/money.svg";
import PaymentCard from "./PaymentCard";
import { useSelector } from "react-redux";
import {
  formatDateIST,
  formatIndianNumber,
} from "../common-functions/PaymentCommonFunctions";
import { EOIFinanceStatus, EOIPaymentMode } from "../../../../config/constant";
const TransactionHistory = () => {
  const [open, setOpen] = useState(true);
  const { applicantData } = useSelector((state) => state.voucherForm);
  function transformPayments(apiData) {
    let idCounter = 1;

    return apiData?.map((txn) => {
      const { paidAmount, paymentMode, paymentDetails } = txn;

      const method =
        paymentMode === EOIPaymentMode.OFFLINE
          ? EOIPaymentMode.OFFLINE
          : paymentDetails?.method?.toUpperCase() || "NA";

      const status = txn?.status || EOIFinanceStatus.UNVERIFIED;

      const date = txn?.date
        ? formatDateIST(txn.date)
        : "";

 
      const gatewayPaymentId = paymentDetails?.gatewayPaymentId || paymentDetails?.transactionNumber || paymentDetails?.chequeNumber;

      return {
        id: idCounter++,
        amount: formatIndianNumber(paidAmount),
        date,
        method,
        status,
        gatewayPaymentId,
      };
    });
  }

  const payments = applicantData?.payments
    ? transformPayments(applicantData?.payments)
    : [];
  // 🔹 Dummy Payment Data

  return (
    <Box
      sx={{ border: "1px solid rgba(26, 64, 125, 0.1)", borderRadius: "16px" }}
      p={3}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => setOpen(!open)}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img src={moneyIcon} alt="money-icon" />
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Transaction History
          </Typography>
        </Box>
        <img src={open ? shrinkIcon : expandIcon} alt="toggle-icon" />
      </Box>

      <Collapse in={open}>
        <Box mt={3}>
          {payments?.map((payment) => (
              <PaymentCard
                key={payment?.id}
                amount={payment?.amount}
                date={payment?.date}
                method={payment?.method}
                status={payment?.status}
                transactionId={payment?.gatewayPaymentId}
                isTransactionHistory
              />
            ))}
        </Box>
      </Collapse>
    </Box>
  );
};

export default TransactionHistory;